import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Button, Grid, Input, Item } from "semantic-ui-react";
import ServiceApi from "../../api/service";
import Logo from "../../components/Logo/Logo";
import { validAliquota } from "../../utils/validAliquota";

import { useAppSelector as useSelector } from "../../hooks/redux";

import style from "./style.module.css";

export default function ServiceFormPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const state = useSelector((s) => s);
  const history = useHistory();

  const [price, setPrice] = useState("");
  const [issRate, setIssRate] = useState("");
  const [pisRate, setPisRate] = useState("");
  const [cofinsRate, setCofinsRate] = useState("");

  const validForm = () => {
    if (price === "") {
      return false;
    }
    if (issRate === "" || parseFloat(issRate) <= 0) {
      return false;
    }
    if (pisRate === "" || parseFloat(pisRate) <= 0) {
      return false;
    }
    if (cofinsRate === "" || parseFloat(cofinsRate) <= 0) {
      return false;
    }
    return true;
  };

  const saveService = async () => {
    setLoading(true);
    setError("");
    try {
      await ServiceApi.updateService(
        price,
        state.service.service!.id,
        issRate,
        pisRate,
        cofinsRate
      );
      history.replace("/serviceContract");
    } catch (err) {
      console.log(err);
    }
    setError("Problema para salvar service");
    setLoading(false);
  };

  const loadService = async () => {
    try {
      const updateService = await ServiceApi.getUpdatedService(
        state.service.service!.id
      );
      if (updateService) {
        setPrice(updateService.price);
        setIssRate(updateService.issRate ?? "");
        setPisRate(updateService.pisRate ?? "");
        setCofinsRate(updateService.cofinsRate ?? "");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadService();
    // eslint-disable-next-line
  }, []);

  const validateCurrency = (s: string) => {
    if (s.length === 0) {
      return true;
    }

    if (s.includes(".") && s.split(".").length - 1 > 1) {
      return false;
    }

    if (s.split(".")[1] && s.split(".")[1].length > 2) {
      return false;
    }

    if (s.replaceAll(".", "").match(/\D/g) === null) {
      return true;
    }

    return false;
  };

  return (
    <div className={style.container}>
      <Logo />
      {/* <Header as="h1">Smart Contract</Header> */}
      <Grid columns={6} stackable>
        <Grid.Column>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>Serviço</Item.Header>
                <Item.Meta>
                  <label>Codigo:</label>
                  <span>{state.service.service?.service}</span>
                  <br />
                  <label>Preço atual:</label>
                  <span>{state.service.service?.price}</span>
                  <br />
                  <label>Descrição:</label>
                  <span>{state.service.service?.description}</span>
                  <br />
                  <label>Subdescrição:</label>
                  <span>{state.service.service?.longDescription}</span>
                </Item.Meta>
                <Item.Description>{}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Preço Bruto *:</label>
            <br />
            <Input
              value={price}
              onChange={(e) => {
                if (validateCurrency(e.target.value.replace(",", "."))) {
                  setPrice(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(price))) {
                  setPrice("");
                } else {
                  setPrice(parseFloat(price).toFixed(2));
                }
              }}
              placeholder="Preço Bruto"
            />
          </Grid.Row>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Alíquota ISS % *:</label>
            <br />
            <Input
              value={issRate}
              onChange={(e) => {
                if (validAliquota(e.target.value.replace(",", "."))) {
                  setIssRate(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(issRate))) {
                  setIssRate("");
                } else {
                  setIssRate(parseFloat(issRate).toFixed(2));
                }
              }}
              placeholder="Alíquota ISS"
            />
          </Grid.Row>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Alíquota PIS % *:</label>
            <br />
            <Input
              value={pisRate}
              onChange={(e) => {
                if (validAliquota(e.target.value.replace(",", "."))) {
                  setPisRate(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(pisRate))) {
                  setPisRate("");
                } else {
                  setPisRate(parseFloat(pisRate).toFixed(2));
                }
              }}
              placeholder="Alíquota PIS"
            />
          </Grid.Row>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Alíquota COFINS % *:</label>
            <br />
            <Input
              value={cofinsRate}
              onChange={(e) => {
                if (validAliquota(e.target.value.replace(",", "."))) {
                  setCofinsRate(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(cofinsRate))) {
                  setCofinsRate("");
                } else {
                  setCofinsRate(parseFloat(cofinsRate).toFixed(2));
                }
              }}
              placeholder="Alíquota COFINS"
            />
          </Grid.Row>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row>
            <Button
              onClick={() => {
                history.goBack();
              }}
              color="red"
            >
              Cancelar
            </Button>
            <Button
              loading={loading}
              disabled={!validForm()}
              onClick={saveService}
              primary
            >
              Salvar
            </Button>
            <text className={style.error}>{error}</text>
          </Grid.Row>
        </Grid.Column>
      </Grid>
    </div>
  );
}
